<template>
  <div class="noPhone">
    <div class="npTop">
      <div class="tipInfo"><i class="el-icon-warning"></i>导入的顾客套餐，需激活/合并后才能正常的划扣使用，请知悉</div>
    </div>
    <div class="npMiddle">
      <el-input v-model="searchVal" class="nmInput" placeholder="请输入顾客信息/套餐名称" @keyup.enter.native="getListData(1)"><i slot="suffix" class="el-input__icon el-icon-search" @click="getListData(1)"></i></el-input>
      <el-select v-model="chooseStatus" @change="getListData(1)">
        <el-option label="全部状态" value=""></el-option>
        <el-option label="未激活" value="1"></el-option>
        <el-option label="已激活" value="2"></el-option>
      </el-select>
      <el-button class="nmBtn" @click="getImportRecordList(1)">查看导入历史</el-button>
    </div>
    <div class="nmBottom">
      <el-table :data="customerData">
        <el-table-column prop="customerMsg" label="顾客信息" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="vipCardName" label="套餐名称" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="套餐类型" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.countLimitType == 1 ? '有限次数套餐' : scope.row.countLimitType == 2 ? '无限次数套餐' : '通用次数套餐' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="通用次数">
          <template slot-scope="scope">
            <span>{{ scope.row.countLimitType == 3 ? scope.row.originUseCount : '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="项目名称" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-for="(a,m) in scope.row.itemList" v-show="scope.row.itemList.length > 0" :key="m">{{ a.name }}{{ scope.row.countLimitType == 3 ? '' : '*' }}{{ scope.row.countLimitType == 3 ? '' : scope.row.countLimitType == 2 ? '无限' : a.originResidueCount }}{{ scope.row.itemList.length == (m+1) ? '' : '，' }}</span>
            <span v-show="scope.row.itemList.length == 0">--</span>
          </template>
        </el-table-column>
        <el-table-column label="产品名称" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-for="(b,n) in scope.row.productList" v-show="scope.row.productList.length > 0" :key="n">{{ b.productName }}{{ scope.row.countLimitType == 3 ? '' : '*' }}{{ scope.row.countLimitType == 3 ? '' : scope.row.countLimitType == 2 ? '无限' : b.originResidueCount }}{{ scope.row.productList.length == (n+1) ? '' : '，' }}</span>
            <span v-show="scope.row.productList.length == 0">--</span>
          </template>
        </el-table-column>
        <el-table-column label="到期时间" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.validType == 2 ? '永久有效' : scope.row.pastTime }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="导入时间" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.activateType == 1" class="sOne">待激活</span>
            <span v-else>已激活<el-tooltip effect="light" placement="top-start">
              <div slot="content">员工{{ scope.row.activateTechnicianName }}，于{{ scope.row.activateTime }} 激活</div>
              <i class="el-icon-warning siOne"></i>
            </el-tooltip></span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220">
          <template slot-scope="scope">
            <el-button v-if="scope.row.activateType == 1" type="primary" size="mini" plain @click="activationPackage(scope.row.id)">激活</el-button>
            <el-button v-else type="primary" size="mini" plain @click="jumpDetails(scope.row.phone)">详情</el-button>
            <el-button v-if="scope.row.activateType == 1" type="primary" size="mini" plain @click="onCheckPhoneBook(scope.row.id)">合并</el-button>
            <el-popover v-if="scope.row.activateType == 1" placement="top" width="160" trigger="click">
              <div style="padding: 12px;">
                <p>是否确认删除？</p>
                <div style="text-align: right; margin-top: 10px;">
                  <el-button size="mini" @click="clickBody">取消</el-button>
                  <el-button type="primary" size="mini" @click="delPackage(scope.row.id)">确定</el-button>
                </div>
              </div>
              <yz-btn slot="reference" style="margin-left: 10px;" type="delete">删除</yz-btn>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page.sync="pageNum" :page-sizes="[10, 20, 30, 40, 50 ,100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
    </div>
    <el-dialog class="importDialog" width="1000px" title="导入历史" :visible.sync="historyDialog" :append-to-body="true">
      <el-table :data="historyTableData" :style="historyTableData.length > 0 ? 'width: 100%' : 'width: 100%;margin-bottom: 20px;'">
        <el-table-column prop="createTime" label="导入时间" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="fileName" label="表格名称" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="staffName" label="操作员工" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="导入结果" width="280">
          <template slot-scope="scope">
            <h6 v-if="scope.row.importStatus == 0"><span class="sOne">失败</span><samp>(导入失败{{ scope.row.errorCount }}条)</samp></h6>
            <h6 v-else-if="scope.row.importStatus == 1"><span class="sTwo">成功</span><samp>(成功导入{{ scope.row.successCount }}条数据)</samp></h6>
            <h6 v-else><span class="sThree">部分失败</span><samp>(成功导入{{ scope.row.successCount }}条，导入失败{{ scope.row.errorCount }}条)</samp></h6>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="240">
          <template slot-scope="scope">
            <yz-btn v-if="scope.row.importStatus != 0" type="primary" @click="onDownloadReport(scope.row.allOriginFilePath)">下载导入报表</yz-btn>
            <yz-btn v-if="scope.row.importStatus != 1" type="delete" @click="onDownloadReport(scope.row.allFilePath)">下载失败报表</yz-btn>
          </template>
        </el-table-column>
      </el-table>
      <span v-if="historyTableData.length > 0" slot="footer" class="dialog-footer">
        <el-pagination :page-size="10" background layout="prev, pager, next, jumper" :total="historyTabletotal" @current-change="getImportRecordList"></el-pagination>
      </span>
    </el-dialog>

    <customerDialog v-if="customerVisible" :customer-visible="customerVisible" :title="type" @close="onCloseDialog" />

    <book :show.sync="bookVisible"></book>
  </div>
</template>

<script>
import customerDialog from './template/customer_detail';
import book from '../stage/template/beautyCard/template/book';
import {
  getNoPhoneCustomerPackageList, getImportRecordList, bindingCustomerPackage, deleteCustomerPackage
} from './api';

export default {
  components: {
    customerDialog,
    book,
  },
  data() {
    return {
      searchVal: '',
      chooseStatus: '',
      customerData: [],
      historyTableData: [],
      historyTabletotal: 0,
      historyDialog: false, // 查看导入历史弹窗
      pageNum: 1,
      pageSize: 10,
      totalCount: 0,
      customerVisible: false,
      type: '新增顾客',
      bookVisible: false,
      chooseActivationId: '',
    };
  },
  activated() {
    this.getListData(1);
  },
  methods: {
    // 下载错误报告
    onDownloadReport(url) {
      window.open(url);
    },
    checkMember(phone) {
      setTimeout(() => {
        this.confirmActivation(phone, 2);
      }, 10);
    },
    confirmActivation(phone, status) {
      const vm = this;
      const data = {
        mainId: window.sessionStorage.mainId,
        clientVipCardId: this.chooseActivationId,
        phone,
      };
      bindingCustomerPackage(data).then((res) => {
        if (res.code == 0) {
          vm.$message({ message: status == 2 ? '合并成功，可点击详情查看具体信息' : '激活成功，可点击详情查看具体信息', type: 'success' });
          vm.getListData(vm.pageNum);
        } else {
          console.log(res);
        }
      });
    },
    // 查询顾客列表
    onCheckPhoneBook(id) {
      this.chooseActivationId = id;
      this.bookVisible = true;
    },
    clickBody() {
      $('body').click();
    },
    // 删除未激活的顾客套餐
    delPackage(id) {
      const data = {
        busId: window.sessionStorage.busId,
        clientVipCardId: id
      };
      deleteCustomerPackage(data).then((res) => {
        if (res.code == 0) {
          this.$message({ message: '删除成功', type: 'success' });
          this.getListData(1);
          $('body').click();
        } else {
          console.log(res);
        }
      });
    },
    // 关闭激活套餐弹窗
    onCloseDialog(val) {
      this.customerVisible = val;
    },
    // 激活套餐
    activationPackage(id) {
      if (this.Lib.checkPower('beauty-2-xzgk') == false) return;
      this.chooseActivationId = id;
      this.type = '新增顾客';
      this.customerVisible = true;
    },
    // 跳转顾客套餐详情
    jumpDetails(phone) {
      if (this.Lib.checkPower('beauty-2-ckgkxq2') == false) return;
      window.sessionStorage.customerPhone = phone;
      this.$router.push({
        name: 'customer-info',
        params: {
          name: 'customer-package'
        }
      });
    },
    // 查看导入历史
    getImportRecordList(val) {
      this.historyDialog = true;
      const vm = this;
      const data = {
        mainId: window.sessionStorage.mainId,
        pageNum: val,
        type: 6,
      };
      getImportRecordList(data).then((res) => {
        if (res.code == 0) {
          vm.historyTableData = res.data.records || [];
          vm.historyTabletotal = res.data.total;
        } else {
          console.log(res);
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getListData(1);
    },
    handleCurrentChange(val) {
      this.getListData(val);
    },
    // 获取无手机号顾客套餐数据
    getListData(val) {
      this.pageNum = val;
      const vm = this;
      const data = {
        mainId: window.sessionStorage.mainId,
        pageNum: vm.pageNum,
        pageSize: vm.pageSize,
        keyWord: vm.searchVal,
        activityType: vm.chooseStatus,
      };
      getNoPhoneCustomerPackageList(data).then((res) => {
        if (res.code == 0) {
          vm.customerData = res.data.records || [];
          this.totalCount = res.data.total;
        } else {
          console.log(res);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.noPhone {
  margin-bottom: 20px;
  .npTop {
    width: 100%;
    margin-bottom: 15px;
    .tipInfo {
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      padding: 0 15px;
      color: #E6A23C;
      background: #FDF6EC;
      border-radius: 4px;
      border: 1px solid #FAECD8;
      i {
        padding-right: 5px;
      }
    }
  }
  .npMiddle {
    height: 40px;
    line-height: 40px;
    margin-bottom: 20px;
    .nmInput {
      width: 220px;
      float: left;
      margin-right:  20px;
    }
    .nmBtn {
      float: right;
    }
  }
  .nmBottom {
    margin-bottom: 20px;
    .sOne {
      color: #f56c6c;
    }
    .siOne {
      color:#D2D2D2;
      font-size:14px;
      padding-left: 5px;
    }
  }
}
.importDialog {
  width: 100%;
  h6 {
    font-size: 14px;
    color: #333;
    .sOne {
      color: #f56c6c;
    }
    .sTwo {
      color: #333;
    }
    .sThree {
      color: #67c23a;
    }
    samp {
      color: #999;
    }
  }
}
</style>
